import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ListAnkeiler from '../../sec_ankeiler/_ankeiler-list/component';

import './styles/styles.scss';

class BannerSearch extends Component {
  get store() {
    return this.props.store;
  }

  render() {
    const { store, products } = this.props;
    return (
      <div className="banner banner-search result-list">
        <ListAnkeiler
          store={store}
          {...products[0]}
        />
      </div>
    );
  }
}
BannerSearch.propTypes = {
  products: PropTypes.array,
  store: PropTypes.object,
};
export default BannerSearch;
